import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const BrandPreviewPanel = ({ profileData }) => {
  const {
    companyName = 'Your Company',
    logoPreview = null,
    primaryColor = '#2563EB',
    secondaryColor = '#64748B',
    ctaButtonText = 'Get Free Quote'
  } = profileData;

  return (
    <div className="bg-card border border-border rounded-lg p-6 sticky top-24">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-text-primary mb-1">Live Preview</h3>
        <p className="text-sm text-text-secondary">
          See how your branding appears in the visualizer
        </p>
      </div>
      <div className="space-y-4">
        <div className="border-2 border-border rounded-lg overflow-hidden">
          <div
            className="p-4 flex items-center justify-between"
            style={{ backgroundColor: primaryColor }}
          >
            <div className="flex items-center gap-3">
              {logoPreview ? (
                <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center overflow-hidden">
                  <Image
                    src={logoPreview}
                    alt="Company logo preview in visualizer header showing brand identity"
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
              ) : (
                <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center text-lg font-bold">
                  {companyName?.charAt(0)?.toUpperCase()}
                </div>
              )}
              <span className="text-white font-semibold">{companyName}</span>
            </div>
            <button
              className="px-4 py-2 bg-white rounded-lg text-sm font-medium"
              style={{ color: primaryColor }}
              disabled
            >
              {ctaButtonText}
            </button>
          </div>

          <div className="p-6 bg-background">
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <div
                  className="w-8 h-8 rounded-lg flex items-center justify-center"
                  style={{ backgroundColor: `${primaryColor}20`, color: primaryColor }}
                >
                  <Icon name="Grid3x3" size={16} />
                </div>
                <span className="text-sm text-text-primary">Floor Type Selection</span>
              </div>
              <div className="flex items-center gap-2">
                <div
                  className="w-8 h-8 rounded-lg flex items-center justify-center"
                  style={{ backgroundColor: `${secondaryColor}20`, color: secondaryColor }}
                >
                  <Icon name="Palette" size={16} />
                </div>
                <span className="text-sm text-text-primary">Color Customization</span>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div className="p-3 bg-muted rounded-lg">
            <p className="text-xs text-text-secondary mb-2">Primary Color</p>
            <div className="flex items-center gap-2">
              <div
                className="w-6 h-6 rounded border border-border"
                style={{ backgroundColor: primaryColor }}
              />
              <span className="text-xs font-mono text-text-primary">{primaryColor}</span>
            </div>
          </div>
          <div className="p-3 bg-muted rounded-lg">
            <p className="text-xs text-text-secondary mb-2">Secondary Color</p>
            <div className="flex items-center gap-2">
              <div
                className="w-6 h-6 rounded border border-border"
                style={{ backgroundColor: secondaryColor }}
              />
              <span className="text-xs font-mono text-text-primary">{secondaryColor}</span>
            </div>
          </div>
        </div>

        <div className="p-3 bg-muted/50 rounded-lg">
          <div className="flex items-start gap-2">
            <Icon name="Eye" size={16} className="text-text-secondary mt-0.5" />
            <p className="text-xs text-text-secondary">
              Changes are applied instantly across all visualizer instances and embedded implementations
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandPreviewPanel;